import { Flex, TextInput, Textarea, DatePicker } from '@applyboard/crystal-ui';
import { AdditionalDetailsType } from '../types';

const minDate = new Date();
const maxDate = new Date(2100, 0, 1);

export function AdditionalDetails({
  additionalDetails,
  setAdditionalDetails,
  enableFeeFields,
}: {
  additionalDetails: AdditionalDetailsType;
  setAdditionalDetails: (details: AdditionalDetailsType) => void;
  enableFeeFields?: boolean;
}) {
  const handleInputChange = (field: keyof AdditionalDetailsType, value: string) => {
    setAdditionalDetails({
      ...additionalDetails,
      [field]: value,
    });
  };
  return (
    <Flex direction="column" gap={4}>
      {enableFeeFields && (
        <>
          <Flex direction="row" gap={4}>
            <Flex.Item basis={{ xs: '100%', sm: 'calc(50% - 8px)' }}>
              <TextInput
                label="First Payment Fee"
                placeholder="e.g. $1500"
                onChange={(v) => handleInputChange('firstPaymentFee', v)}
                value={additionalDetails.firstPaymentFee?.toString() ?? ''}
                aria-label="First Payment Fee"
              />
            </Flex.Item>
            <Flex.Item basis={{ xs: '100%', sm: 'calc(50% - 8px)' }}>
              <DatePicker
                label="First Payment Fee Due"
                onChange={(v) => handleInputChange('firstPaymentDate', v)}
                value={additionalDetails.firstPaymentDate ?? ''}
                maxDate={maxDate.toISOString()}
                minDate={minDate.toISOString()}
                aria-label="First Payment Fee Due"
                granularity="day"
              />
            </Flex.Item>
          </Flex>
          <Flex direction="row" gap={4}>
            <Flex.Item basis={{ xs: '100%', sm: 'calc(50% - 8px)' }}>
              <TextInput
                label="Second Payment Fee"
                placeholder="e.g. $1500"
                onChange={(v) => handleInputChange('secondPaymentFee', v)}
                value={additionalDetails.secondPaymentFee?.toString() ?? ''}
                aria-label="Second Payment Fee"
              />
            </Flex.Item>
            <Flex.Item basis={{ xs: '100%', sm: 'calc(50% - 8px)' }}>
              <DatePicker
                label="Second Payment Fee Due"
                onChange={(v) => handleInputChange('secondPaymentDate', v)}
                value={additionalDetails.secondPaymentDate ?? ''}
                maxDate={maxDate.toISOString()}
                minDate={minDate.toISOString()}
                aria-label="Second Payment Fee Due"
                granularity="day"
              />
            </Flex.Item>
          </Flex>
          <Flex direction="row" gap={4}>
            <Flex.Item basis={{ xs: '100%', sm: 'calc(50% - 8px)' }}>
              <TextInput
                label="Tuition Fee"
                placeholder="e.g. $1500"
                onChange={(v) => handleInputChange('tuitionFee', v)}
                value={additionalDetails.tuitionFee?.toString() ?? ''}
                aria-label="Tuition Fee"
              />
            </Flex.Item>
            <Flex.Item basis={{ xs: '100%', sm: 'calc(50% - 8px)' }}>
              <TextInput
                label="Ancillary Fee"
                placeholder="e.g. $1500"
                onChange={(v) => handleInputChange('ancillaryFee', v)}
                value={additionalDetails.ancillaryFee?.toString() ?? ''}
                aria-label="Ancillary Fee"
              />
            </Flex.Item>
          </Flex>
        </>
      )}
      <Textarea
        label="Custom Note"
        intent="secondary"
        onChange={(v) => handleInputChange('additionalNotes', v)}
        value={additionalDetails.additionalNotes ?? ''}
        helpText="Add any additional information or notes about the offer."
        aria-label="Custom Note"
      />
    </Flex>
  );
}
